export class Rating {
    comment: string;
    applicationReferenceId: number;
    ratingId: number;
}